import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import { IApiClientError } from "../../shared/ApiClient";
import { useAlerts} from "../../contexts/AlertsContext";
import AlertMessageType from "../common/alert_message/AlertMessageType";
import DialogWindowType from "../common/dialog_window/DialogWindowType";
import Loading from "../common/Loading";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import Material from "../../model/Material";
import APIEndPoints from "../../utils/APIEndPoints";
import APIError from "../../utils/APIError";

interface IMaterialsListElementProps {
  data: Material;
  canEdit: boolean;
  navigable: boolean;
  onDelete: () => void;
}

function MaterialsListElement({ data, canEdit, navigable, onDelete }: IMaterialsListElementProps) {
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const alertsManager = useAlerts();

  // Local state for the editable name
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(data.name);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, [apiClient]);

  if (loading) {
    return <Loading />;
  }


  const processAPIErrors = (serverError: IApiClientError) => {
    try {
      // convert the error to ChemiNovaAPI custom errors
      const apiErrors = serverError.details.response.data as APIError[];
      console.log(serverError);
      console.log(apiErrors);
    } catch (exception) {
      console.log(exception);
    }
  };

  // Toggle edit mode
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Handle input change
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    data.name = e.target.value;
  };

  const handleDelete = () => {
    if (!data.id) return;
    apiClient
      ?.delete({
        url: APIEndPoints.MATERIALS.ONE(data.id),
      })
      .then(() => {
        alertsManager.showAlertMessage({
          type: AlertMessageType.SUCCESS,
          message: "Material deleted successfully",
        });
        onDelete();
      })
      .catch((error: IApiClientError) => {
        if (!error.processed) {
          processAPIErrors(error);
        }
      });

  }


  // Handle saving the updated name
  const handleEdit = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e || e.key === "Enter") {
        if (!data.id) return;
        
        apiClient
        ?.put({
          url: APIEndPoints.MATERIALS.ONE(data.id),
          body: data,
        })
        .then((response) => {
          alertsManager.showAlertMessage({
            type: AlertMessageType.SUCCESS,
            message: "Material record updated successfully",
          });
        })
        .catch((error: IApiClientError) => {
          if (!error.processed) {
            processAPIErrors(error);
          }
        });

      setIsEditing(false);
      console.log("Updated Name:", name); // You can add API call to save it here
    }
  };
  

  return (
    <div
      className="p-4 w-full border border-solid border-gray-400 rounded-xl mt-3 mb-5 hover:bg-blue-50 cursor-pointer  details-section"
    >
      <div className="flex flex-col flex-wrap">
        <div className="flex flex-col flex-wrap items-start">
          <div className="flex flex-row justify-between w-full mr-0 pr-0">
          
          <div className="grid grid-cols-10 gap-1 w-full">

                {/* Left Column */}
                <div className="col-span-5">
                  <div className="flex items-center">
                    {/* Toggle between text and input field */}
                    {isEditing ? (
                          <input
                              type="text"
                              value={name}
                              onChange={handleNameChange}
                              onBlur={() => handleEdit()} // Save on blur
                              onKeyDown={handleEdit} // Save on Enter
                              className="w-full min-w-0 p-2 border border-gray-300 rounded-md"
                              autoFocus
                          />
                      ):(
                          <h1 className="text-xl text-left font-bold mb-2 mt-0 text-left break-words" onClick={handleEditClick}> {data.name}</h1>
                      )
                    }
                  </div>
                </div>

                {/* Right Column */}
                <div className="col-span-5 text-right">
                    <Button
                        label="Edit"
                        purpose={ButtonAction.EDIT}
                        type={ButtonType.ICON}
                        onClick={handleEditClick}
                    />
                    <Button
                        label="Delete"
                        purpose={ButtonAction.DELETE}
                        type={ButtonType.ICON}
                        onClick={handleDelete}
                    />
                </div>
               
            </div>

          </div>

          
        
            {/* <p className="text-gray-700 text-md mb-4 text-left">GUID: {data.GUID}</p> */}
            {/* <p className="text-gray-700 text-md mb-4">GUID: {data.GUID}</p> */}
        </div>
      </div>
    </div>
  );
}

export default MaterialsListElement;